export default __webpack_public_path__ + "src/_images/LS_LocationsIcon.png";